import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.RefundConfigTemplate.List.IRequest;
type Response = Api.Core.RefundConfigTemplate.List.IResponse;
type Headers = Api.Core.RefundConfigTemplate.List.IHeaders;
const url = '/api/ProductManagement/RefundConfigTemplate';
export default async function refundConfigTemplateListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
